import React from 'react';

import Head from './Head';
import Row from './Row';

import { TableList, TableBody } from './styles';

const Table = ({ data, head }) => {
  if (!data[0]) {
    return <p>...</p>;
  }

  const keys = Object.keys(data[0]);

  return (
    <TableList>
      <Head head={head} keys={keys} />
      <TableBody>
        {data.map((item, index) => (
          <Row item={item} key={String(index)} />
        ))}
      </TableBody>
    </TableList>
  );
};

export default Table;
